planb = {
	resolution: '',
	isMobileApp: false,

	init: function () {
		var
			self = this;

		self.checkMobile();

		jQuery('.js-closeable .js-close').on('click', function () {
			var
				parent = jQuery(this).closest('.js-closeable');

			$.cookie('wndclosed-' + parent.attr('id'), true);

			parent.remove();
			console.log('wndclosed-' + parent.attr('id'));
		});

		//Инициализация форм
		if (_forms.length) {
			for (var i = 0; i < _forms.length; i++)
				new Form($(_forms[i]));
		}

		//Обработка изменения размеров экрана
		jQuery(window).resize(function () {
			self.checkMobile();
		});

		//Проверить, запущен ли сайт из мобильного приложения
		self.checkMobileApp();

		self.mainPage();
	}, 

	//-------------------------------------------------
	//Проверить, какому устройству соответствует разрешение экрана
	checkMobile: function () {
		var
			width = jQuery(window).width(),
			result = '';

		if (width < 768) result = 'mobile';
		else if (width < 1290) result = 'tablet';
		else result = 'desktop';

		if (this.resolution != result) {
			this.resolution = result;
			jQuery(window).trigger('resolution');
		}
	},

	//-------------------------------------------------
	//Проверить, запущен ли сайт из мобельного приложения
	checkMobileApp: function () {
		var
			userAgent = navigator.userAgent || navigator.vendor || window.opera,
			result = false;

		//Проверка на Android WebView
		if (/Android/i.test(userAgent))
			if (/wv/.test(userAgent)) result = true;

			// Проверка для iOS WebView
			else if (/iPhone|iPad|iPod/i.test(userAgent))
				if (navigator.standalone) result = true;

		this.isMobileApp = result;
	},

	//-------------------------------------------------
	//Обратный отсчёт
	countdown: function(elemId, seconds, onStop) {
		let
			elem = $(`#${elemId}`),
			timeoutId;

		seconds = parseInt(seconds);

		function print(sec) {
			let
				m = Math.floor(sec / 60),
				s = sec % 60;

			elem.html(
				(m < 10 ? '0' : '') + m + ':' +
				(s < 10 ? '0' : '') + s
			);
		}

		function tick() {
			print(seconds);

			localStorage.setItem(elemId, seconds);

			if (seconds-- <= 0) {
				clearInterval(timeoutId);
				localStorage.removeItem(elemId);

				if (onStop) onStop();
			}
		}

		tick();

		timeoutId = setInterval(tick, 1000);
	},

	//Инициализировать скрипт mask
	maskInit: function () {
		//Номер телефона
		$('.js-phone-iti:not(.ok)').each(function () {
			var iti = window.intlTelInput(
				this,
				{
					autoPlaceholder: 'aggressive',
					showSelectedDialCode: true,
					// onlyCountries: ['ru', 'kz', 'by', 'kg', 'ae', 'ua', 'tj', 'md', 'am'],
					initialCountry: 'ru',
					// countrySearch: false,
					dropdownContainer: document.body,
					fixDropdownWidth: true,
					nationalMode: false,
					customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
						return selectedCountryPlaceholder.replace(/[0-9]/g, '_');
					},
				}
			);

			$(this).on('input', function (event) {
				var
					$target = $(event.target),
					$hidden = $(`#${$target.data('hidden')}`);

				$hidden.val(iti.getNumber());

				if (iti.isValidNumber()) $hidden.trigger('maskCompleted');
				else $hidden.trigger('maskUncompleted');
			});

			$(this).addClass('ok');
		});

		//Email
		$('.js-email:not(.ok)').each(function () {
			$(this).on('keyup', function () {
				var
					$input = $(this),
					text = $input.val();

				if (
					text.length > 10 &&
					text.includes('@') &&
					text.includes('.')
				)
					$input.trigger('maskCompleted');

				else $input.trigger('maskUncompleted');
			});

			$(this).addClass('ok');
		});
	},

	mainPage: function () {
		if (this.checkMobile() == 'desktop') {

		}

		$('.main-search-field input').on('focus blur', function (e) {
			let field = $(this).closest('.main-search-field');
			if (e.type == 'focus')
				field.addClass('focus');
			else
				field.removeClass('focus');
		});
		const searchTips = $('.main-search-tips');
		let searchTimeout = null;

		$('.main-search-field input').on('keyup', function () {
			let str = $(this).val().trim().toLowerCase(); // Приводим ввод к нижнему регистру для точного поиска
			let field = $(this).closest('.main-search-field');

			// Сбрасываем предыдущий таймер, чтобы поиск срабатывал только когда пользователь закончил ввод
			clearTimeout(searchTimeout);

			if (str.length > 2) {
				searchTimeout = setTimeout(() => {
					let hasResults = false;

					// Перебираем все элементы подсказок (замените селектор контейнера, если нужно)
					$('.main-search-item').each(function () {
						// Находим текст названия внутри <p> и тоже приводим к нижнему регистру
						let itemName = $(this).find('p').text().trim().toLowerCase();

						// Проверяем, входит ли введенная строка в название
						if (itemName.indexOf(str) !== -1) {
							$(this).show(); // Показываем совпавший элемент
							hasResults = true;
						} else {
							$(this).hide(); // Скрываем неподходящий элемент
						}
					});

					// Если нашли хотя бы один элемент, открываем блок подсказок
					if (hasResults) {
						field.addClass('tips-open');
						searchTips.addClass('open'); // Убедитесь, что переменная searchTips объявлена выше в вашем коде
						$('body').addClass('search-open');
					} else {
						// Если по фильтру ничего не нашлось, скрываем подсказки
						field.removeClass('tips-open');
						searchTips.removeClass('open');
						$('body').removeClass('search-open');
					}
				}, 300); // 300мс — оптимальное время задержки (debounce)
			} else {
				// Если введено меньше 3-х символов, сбрасываем фильтр и скрываем блок
				$('.main-search-item').show();
				field.removeClass('tips-open');
				searchTips.removeClass('open');

				$('body').removeClass('search-open');
			}
		});

		$(document).click(function (e) {
			if (searchTips.is(':visible') && notClickOnTarget(e, searchTips) && notClickOnTarget(e, $('.main-search-field'))) {

				searchTips.removeClass('open');
				$('body').removeClass('search-open');
			}

		});

		if ($('.main-tours-slider-wrapper').length) {
			new Swiper('.main-tours-slider-wrapper', {
				slidesPerGroupAuto: true,
				grabCursor: true,
				autoHeight: false,
				watchOverflow: true,
		
				navigation: {
					nextEl: '.swiper-nav-arrow-next',
					prevEl: '.swiper-nav-arrow-prev',
					disabledClass: 'swiper-nav-arrow-disabled', // ваш класс для disabled-состояния
				}, 
		
				breakpoints: {
					0: {
						slidesPerView: 1.25,
						spaceBetween: 8,
					},
					640: {
						slidesPerView: 2.25,
						spaceBetween: 8,
					},
					1200: {
						slidesPerView: 3,
						spaceBetween: 20,
					},
				}
			});
		}
	}
}

//-------------------------------------------------
//Вывести лог в консоль
function dd(val) {
	console.log(val);
}

//-------------------------------------------------
//Проверить переменную на существование
function isset(val) {
	return typeof val !== 'undefined';
}

//-------------------------------------------------
//Получить список url параметров
function urlParams() {
	return (new URL(document.location)).searchParams;
}

//-------------------------------------------------
//Удалить параметр из url
function removeUrlParam(url, parameter) {
	url = url || window.location.href;

	var parts = url.split('?');
	var paramValue = null;

	if (parts.length >= 2) {
		var prefix = encodeURIComponent(parameter) + '=';
		var pars = parts[1].split(/[&;]/g);

		for (var i = pars.length; i-- > 0;) {
			if (pars[i].lastIndexOf(prefix, 0) !== -1) {
				paramValue = decodeURIComponent(pars[i].substring(prefix.length)); // Извлечение значения параметра
				pars.splice(i, 1); // Удаление параметра из массива
			}
		}

		return {
			url: parts[0] + (pars.length > 0 ? '?' + pars.join('&') : ''),
			value: paramValue
		};
	}

	return {
		url: url,
		value: paramValue
	};
}

//-------------------------------------------------
//Получить корневой домен
function getDomain() {
	return '.' + location.hostname.split('.').slice(-2).join('.');
}

//-------------------------------------------------
//Установить Cookie
function setCookie(name, value, allDomains = true, expires = -1) {
	let options = {
		path: '/',
	};

	if (allDomains)
		options.domain = getDomain();

	if (expires >= 0)
		options.expires = expires;

	$.cookie(
		name, value,
		options
	);
}

//-------------------------------------------------
//Получить Breakpoint по имени
function getBreakpoint(name) {
    return parseInt(
        getComputedStyle(document.documentElement)
            .getPropertyValue(`--screen-${name}`)
            .trim()
    );
}

function delay(ms) {
	return new Promise((resolve) => {
		setTimeout(() => {
			resolve("resolved");
		}, ms);
	});
}

function notClickOnTarget(e, obj) {
	return !obj.is(e.target) && obj.has(e.target).length === 0;
}

jQuery(document).ready(function () {
	planb.init();
});

document.addEventListener('DOMContentLoaded', function(event) {
	if(document.querySelector('[data-open-widget]')) {

		let text = document.querySelector('[data-open-widget]').innerHTML

		document.querySelector('[data-open-widget]').addEventListener('click', () => {
			document.querySelector('[data-widget]').classList.toggle('is-open')

			if(document.querySelector('[data-widget]').classList.contains('is-open')) {
				document.querySelector('[data-open-widget]').innerHTML = 'Свернуть'
			}else {
				document.querySelector('[data-open-widget]').innerHTML = text
			}
			
		})
	}
});